import styled from 'styled-components';

export const PlansStyle = styled.div`
  width: 100%;
  min-height: calc(100dvh - 80px);
  font-size: 14px;
  line-height: 20px;
  padding: 8px 0 24px;
  display: flex;
  flex-direction: column;
  position: relative;
  color: var(--ink);

  .btn-back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-bottom: 12px;
    border-radius: 10px;
    border: 1px solid var(--line);
    background: var(--card);
    font-size: 20px;
    color: var(--ink);
    box-shadow: var(--shadow);
    transition:
      border-color 0.15s var(--ease),
      box-shadow 0.15s var(--ease);

    &:hover {
      border-color: var(--o1);
      box-shadow: var(--shadow-lg);
    }
  }

  .header {
    width: 100%;
    text-align: center;
    margin-bottom: 28px;

    h1 {
      margin: 0 0 18px;
      font-size: 28px;
      line-height: 34px;
      font-weight: 800;
      color: var(--ink);
      letter-spacing: -0.02em;

      @media (min-width: 768px) {
        font-size: 32px;
        line-height: 38px;
      }
    }
  }

  .tab-btns {
    max-width: 260px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 4px;
    border-radius: 999px;
    border: 1px solid var(--line);
    background: var(--band);

    .btn {
      flex: 1;
      display: inline-block;
      font-size: 14px;
      line-height: 18px;
      font-weight: 650;
      padding: 8px 14px;
      border-radius: 999px;
      color: var(--quiet);
      background: transparent;
      transition:
        background 0.15s var(--ease),
        color 0.15s var(--ease),
        box-shadow 0.15s var(--ease);

      &:hover {
        color: var(--ink);
      }

      &.active {
        background: var(--card);
        color: var(--ink);
        box-shadow: var(--shadow);
      }
    }
  }

  .tab-content {
    flex-grow: 1;
    width: 100%;
    margin: 0 0 24px;
  }

  .plan-wrap {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    width: 100%;

    @media (min-width: 768px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 20px;
    }
  }

  .plan-col {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 480px;
    padding: 22px;
    border-radius: 18px;
    border: 1px solid var(--line);
    background: var(--card);
    color: var(--ink);
    box-shadow: var(--shadow);
    transition:
      border-color 0.2s var(--ease),
      box-shadow 0.2s var(--ease);

    &:hover {
      border-color: var(--o1);
      box-shadow: var(--shadow-lg);
    }

    &.featured {
      border-color: var(--o1);
      box-shadow: var(--shadow-lg);
      background: linear-gradient(180deg, var(--o-tint) 0%, var(--card) 42%);
    }

    .text-box {
      width: 100%;
      min-height: 150px;
      margin-bottom: 20px;

      .title {
        display: block;
        font-size: 22px;
        line-height: 28px;
        font-weight: 800;
        margin-bottom: 8px;
        color: var(--ink);
      }

      p {
        margin: 0;
        color: var(--quiet);
        font-size: 14px;
        line-height: 20px;
      }
    }

    .price-box {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 6px;
      color: var(--quiet);
      padding-top: 20px;

      .price {
        display: block;
        font-size: 30px;
        line-height: 34px;
        font-weight: 800;
        color: var(--ink);
      }

      .text {
        display: block;
        font-size: 13px;
        line-height: 18px;
      }
    }

    .feature-list {
      flex-grow: 1;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 12px;
        color: var(--fg-2);
        font-size: 14px;
        line-height: 20px;

        .icon {
          flex-shrink: 0;
          margin-top: 3px;
          color: var(--o2);
        }
      }
    }

    button {
      margin-bottom: 20px;
      font-weight: 700;
      padding: 14px 10px;
    }
  }

  .footer {
    width: 100%;
    text-align: center;

    .text-holder {
      max-width: 400px;
      margin: 0 auto;
      font-size: 14px;
      line-height: 20px;
      color: var(--quiet);

      p {
        margin-bottom: 16px;
      }
    }
  }
`;
